import { render, staticRenderFns } from "./UpgradeDocumentList.vue?vue&type=template&id=5e53a109&scoped=true"
import script from "./UpgradeDocumentList.vue?vue&type=script&lang=js"
export * from "./UpgradeDocumentList.vue?vue&type=script&lang=js"
import style0 from "./UpgradeDocumentList.vue?vue&type=style&index=0&id=5e53a109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53a109",
  null
  
)

export default component.exports